import { PageFrame } from "../../components/page_frame";
import { TransferRecommendationsHubToSpokeContainer } from "./container";

export default function TransferRecommendationsHubToSpokePage() {
  return (
    <PageFrame>
      <TransferRecommendationsHubToSpokeContainer />
    </PageFrame>
  );
}
